import React from 'react';
import '../../styles/scss/components/equote-form-success-message-container.scss';

const FormSubmissionConfirmation = () => {
  return (
    <div className="equote-successful-form-container">
      <h1>Congratulations!</h1>
      <h2>Your request has been successfully sent.</h2>
    </div>
  )
}

export default FormSubmissionConfirmation;